export default __webpack_public_path__ + "static/jensen-show-logo-086c3ebb3b6dec952a52f57d83d6c12d.png";